const createReadMore = require('lib/read-more');
import { isMobile } from 'lib/utils';

$('.testimonials-container .results-list li .inner-text').each(function() {
    createReadMore(this, {
        maxChars: isMobile() ? 150 : 300
    });
});


// WEBPACK FOOTER //
// ./assets/js/app/pages/testimonials.js